<template>
    <div class="wework-steps-install">
        <steps-head :title="$t('请选择以下任一应用授权安装')">
            <!-- <template slot="desc">
                请使用和企点主体信息相同的企业微信来授权，如提示“该应用已安装”，请前往<a
                    href="https://work.weixin.qq.com/wework_admin/loginpage_wx"
                    target="_blank"
                    >企业微信后台</a
                >先将应用卸载
                <br />
                安装应用时请选择应用的可见范围，在可见范围内的企业成员才可使用对应的应用。如需修改可见范围，可前往<a
                    href="https://work.weixin.qq.com/wework_admin/loginpage_wx"
                    target="_blank"
                    >企业微信后台</a
                >-应用管理。
            </template> -->
            <v-status-bar
                slot="desc"
                kind="slight-warning"
            >
                <i18n-t path="请使用具备企微超管权限的企业微信账号来授权，如提示“该应用已安装”，请前往{link}先将应用卸载" tag="span">
                    <a slot="link" href="https://work.weixin.qq.com/wework_admin/loginpage_wx" target="_blank">{{ $t('企业微信后台') }}</a>
                </i18n-t>
                <br>
                <i18n-t path="安装应用时请选择应用的可见范围，在可见范围内的企业成员才可使用对应的应用。如需修改可见范围，可前往{link}-应用管理。" tag="span">
                    <a slot="link" href="https://work.weixin.qq.com/wework_admin/loginpage_wx" target="_blank">{{ $t('企业微信后台') }}</a>
                </i18n-t>
            </v-status-bar>
        </steps-head>
        <app-install-list @installSuccess="onInstallSuccess" />
        <steps-bottom
            :is-last-step="isLastStep"
            :btn-disabled="btnDisabled"
            @btnClick="onBtnClick"
            :desc-txt="$t('绑定完成后，仍可以继续授权安装应用')"
        />
    </div>
</template>

<script>
import StepsHead from '../../steps-head';
import StepsBottom from '../../steps-bottom';
import AppInstallList from '../../app-install-list';

export default {
    components: {
        StepsHead,
        StepsBottom,
        AppInstallList,
    },

    props: {
        isLastStep: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            btnDisabled: true, // 只要有一个应用安装成功 btnDisabled变为false
        };
    },

    methods: {
        // 点击下一步按钮emit stepComplete事件
        onBtnClick() {
            this.$emit('stepComplete');
        },

        onInstallSuccess() {
            this.btnDisabled = false;
        },
    },
};
</script>
